export default __webpack_public_path__ + "static/media/bbrfaUSD.339af9c6.png";